import { useMemo } from 'react';

export function useMicromagPreview(story = null) {
    return useMemo(() => {
        if (story === null) {
            return null;
        }
        const { components = null, metadata = null } = story || {};
        const { description = null } = metadata || {};
        const [firstScreen = null] = components || [];
        return {
            ...(story || {}),
            description: description,
            components: [firstScreen],
        };
    }, [story]);
}

export default useMicromagPreview;
